import { Chat, Message } from "@/types";

import { axios } from "../axios.instance";

export type UnreadMessageRequest = {
  messageId: string;
};

export type UnreadMessageResponse = Chat & {
  unreadMessages?: Message[];
};

export const unreadMessage = async (body: UnreadMessageRequest): Promise<UnreadMessageResponse> => {
  const { data } = await axios.post(`/chats/messages/${body.messageId}/unread`);

  return data;
};
